import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft, Dices, Gift, Tv } from 'lucide-react';
import SEO from '../components/SEO';

const NotFound: React.FC = () => {
  const popularPages = [
    { path: '/', label: 'Ana Sayfa', icon: Home, description: 'DiMaria Bet ana sayfası' },
    { path: '/slotlar', label: 'Slotlar', icon: Dices, description: 'Slot oyunları' },
    { path: '/canli-casino', label: 'Canlı Casino', icon: Tv, description: 'Canlı casino oyunları' },
    { path: '/etkinlikler/promosyonlar', label: 'Promosyonlar', icon: Gift, description: 'Özel bonuslar' }
  ];

  return (
    <>
      <SEO
        title="Sayfa Bulunamadı - 404"
        description="Aradığınız sayfa bulunamadı. Ana sayfaya dönün veya popüler sayfalarımızı ziyaret edin."
        keywords="404, sayfa bulunamadı, DiMaria Bet, casino"
        url="/404"
      />
      <div className="min-h-screen pt-20 bg-dark-900 flex items-center justify-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* 404 Error */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-12"
          >
            <h1 className="text-9xl md:text-[12rem] font-gaming font-bold text-gradient bg-gradient-to-r from-primary-400 via-primary-500 to-primary-600 bg-clip-text text-transparent mb-4">
              404
            </h1>
            <h2 className="text-3xl md:text-4xl font-gaming font-bold text-white mb-4">
              Sayfa Bulunamadı
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-8">
              Aradığınız sayfa mevcut değil veya taşınmış olabilir. 
              Ana sayfaya dönün veya aşağıdaki popüler sayfalarımızı ziyaret edin.
            </p>
          </motion.div>

          {/* Popular Pages */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="mb-12"
          >
            <h3 className="text-2xl font-gaming font-bold text-white mb-8">
              Popüler Sayfalar
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {popularPages.map((page, index) => {
                const Icon = page.icon;
                return (
                  <motion.div
                    key={page.path}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.6 + index * 0.1 }}
                    whileHover={{ scale: 1.05, y: -5 }}
                  >
                    <Link
                      to={page.path}
                      className="block p-6 bg-dark-700/50 backdrop-blur-sm rounded-xl border border-dark-600 hover:border-primary-500/50 transition-all duration-300 hover:shadow-2xl hover:shadow-primary-500/10"
                    >
                      <Icon className="w-8 h-8 text-primary-400 mx-auto mb-4" />
                      <h4 className="text-lg font-semibold text-white mb-2">
                        {page.label}
                      </h4>
                      <p className="text-gray-400 text-sm">
                        {page.description}
                      </p>
                    </Link>
                  </motion.div>
                );
              })}
            </div>
          </motion.div>

          {/* Action Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link
              to="/"
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-primary-500 to-primary-600 rounded-full hover:scale-105 transition-all duration-300 transform hover:-translate-y-1"
            >
              <Home className="w-5 h-5 mr-3" />
              Ana Sayfaya Dön
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-dark-700/50 backdrop-blur-sm border border-dark-600 rounded-full hover:scale-105 transition-all duration-300 transform hover:-translate-y-1"
            >
              <ArrowLeft className="w-5 h-5 mr-3" />
              Geri Git
            </button>
          </motion.div>

          {/* Additional Help */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1 }}
            className="mt-12 p-6 bg-dark-700/30 rounded-xl border border-dark-600"
          >
            <h4 className="text-lg font-semibold text-white mb-3">
              Yardıma mı ihtiyacınız var?
            </h4>
            <p className="text-gray-400 mb-4">
              Eğer aradığınız sayfayı bulamıyorsanız, canlı destek ekibimizden yardım alabilirsiniz.
            </p>
            <Link
              to="/diger/canli-destek"
              className="inline-flex items-center text-primary-400 hover:text-primary-300 transition-colors"
            >
              Canlı Destek
            </Link>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default NotFound; 